<template>
  <div style="height: 100vh;width: 100vw;">
    <!-- 页头 -->
    <nav-header2 style="position: absolute;z-index: 999;"></nav-header2>
    <div style="height: 60px;"></div>
    <div style="display: flex;height: calc(100% - 60px);width: 100%;">
      <!-- 侧边栏 -->
      <side-bar></side-bar>
      <div style="flex: 1;padding: 10px;background-color: #e4e7ed;display: flex;">
        <div class="content-box" style="width: 0px;">
          <div class="table-list">
            <!-- <div class="tab">
              <span style="color: #999999;">产品管理</span>
            </div> -->
            <div class="title-box">
              <!-- 标题 -->
              <div class="title">增值服务列表</div>
              <!-- 按钮 -->
              <div class="btn-box">
                <!-- <el-button>添加管理员</el-button> -->
                <!-- <div
                  class="btn"
                  @click="addadmin()"
                >添加</div> -->
                <!-- <div
                  class="btn"
                  @click="deleteallshow()"
                >批量删除</div>
                <div class="btn">排序</div>
                <div
                  class="btn"
                  @click="exportExcel()"
                >
                  <img
                    class="exportimg"
                    src="../assets/img/export.png"
                  >
                  导出
                </div> -->
              </div>
            </div>

            <!-- 下拉选择框 -->
            <div class="select-box">
              <!-- <div class="select">
                <el-date-picker
                  @change="changestartdate()"
                  v-model="startdate"
                  type="date"
                  placeholder="日期（起）"
                >
                </el-date-picker>
              </div>
              <div class="select">
                <el-date-picker
                  @change="changestartdate()"
                  v-model="enddate"
                  type="date"
                  placeholder="日期（止）"
                >
                </el-date-picker>
              </div> -->
              <div class="select">
                <el-input clearable v-model="flag" placeholder="请输入内容"></el-input>
              </div>
              <div class="search" @click="handleSearch()">查询</div>
              <div style="margin-left: auto;display: flex;">
                <div class="btn search" @click="addValueAdd()">新增增值服务</div>
                <div class="btn search" @click="handleSearch()">刷新</div>
              </div>
            </div>
            <div class="listsbox hqsjkdata">
              <div>
                <div class="networkListtitle">
                  <div class="useremail titlebox">增傎服务名称</div>
                  <div class="inputcheck">
                    <!-- <div
                    class="titlebox"
                    style="width: 32px;"
                  >
                    <el-checkbox
                      v-model="checkAll"
                      @change="checkall()"
                    ></el-checkbox>
                  </div> -->
                    <div class="username titlebox">
                      单价</div>
                  </div>
                  <div class="usermobile titlebox">支付方式</div>
                  <div class="userfirm titlebox">描述</div>
                  <!-- <div class="userdate titlebox">创建时间</div> -->
                  <!-- <div class="networknum titlebox">是否启用</div> -->
                  <!-- <div class="networknum titlebox">网络数量</div>
                <div class="equipmentnum titlebox">设备数量</div> -->
                  <div class="networkoperate titlebox">
                    <div style="width: 100px; ">操作</div>
                  </div>
                </div>
              </div>
              <div>
                <div class="userList" v-for="i in userList" :key="i.id">
                  <div class="useremail">{{ i.name }}</div>
                  <div class="inputcheck">
                    <!-- <div style="width: 32px;">
                    <el-checkbox v-model="i.checked"></el-checkbox>
                  </div> -->
                    <div class="username">{{ i.price }}</div>
                  </div>
                  <div class="usermobile">
                    <p v-if="i.wechat == 1">微信</p>
                    <p v-if="i.alipay == 1">支付宝</p>
                  </div>
                  <div class="userfirm">{{ i.describe }}</div>
                  <div class="networkoperate">
                    <div class="userkbtn" style="color: #f5222d" @click="shownotice(i.id)">删除</div>
                    <div class="userkbtn" @click="changeValueAdd(i)">编辑</div>
                  </div>

                  <!-- 删除用户 -->
                  <div v-if="i.id == delid" class="notice">
                    <div class="overlay"></div>
                    <div class="deleteallbox">
                      <div style="padding: 20px;">提示</div>
                      <div style="text-align: center;padding: 20px 30px">确认删除此服务？删除后该服务信息将会被彻底删除！
                      </div>
                      <div style="margin-top: 16px;">
                        <div style="display: flex;justify-content: flex-end;">
                          <div @click="shownotice(i)" class="addbtn" style="margin-left: 0px;">取消
                          </div>
                          <div @click="userDelete(i.id)" class="addbtn"
                            style="color: white;background-color: #1677ff;margin-left: 20px;margin-right: 15px;margin-bottom: 20px;">
                            确定</div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div style="position: absolute;width: 98%;bottom: 0px;background: #fefefe;">
            <!-- 分页 -->
            <!-- <div class="currentpage">
              <button
                class="pagination"
                @click="goToPreviousPage()"
                :disabled="currentPage === 1"
                :class="{ 'pagination-hover': currentPage !== 1 }"
              >上一页</button>
              <span
                v-for="page in pages"
                :key="page"
              >
                <button
                  @click="goToPage(page)"
                  class="pagination2"
                  :class="{ 'pagination-active': page === currentPage }"
                >{{
                                    page }}</button>
              </span>
              <button
                class="pagination"
                @click="goToNextPage()"
                :class="{ 'pagination-hover': currentPage !== totalPages }"
                :disabled="currentPage === totalPages"
              >下一页</button>
              <span style="margin-left:10px;">总数：{{fuserList.length}}</span>
            </div> -->
            <el-pagination @size-change="handleSizeChange" style="float: right;margin-bottom: 10px;"
              @current-change="handleCurrentChange" :current-page="current" :pager-count="5"
              :page-sizes="[10, 20, 30, 40]" :page-size="size" layout="total, sizes, prev, pager, next, jumper"
              :total="fuserList">
            </el-pagination>
          </div>
        </div>
      </div>

    </div>
    <!-- 新增 -->
    <el-dialog title="新增" :close-on-click-modal="false" :visible.sync="dialogFormVisible" class="zdyxzcpzk"
      width="692px" :before-close="handleClose">
      <el-form :rules="rules" ref="dialogformdata" :model="formdata" :inline="false">
        <el-form-item label="增值服务名称" prop="name">
          <el-input clearable v-model="formdata.name" size="small" autocomplete="off"
            placeholder="请输入增值服务名称"></el-input>
        </el-form-item>
        <el-form-item label="单价" prop="price">
          <el-input clearable v-model="formdata.price" size="small" autocomplete="off" placeholder="请输入单价"></el-input>
        </el-form-item>
        <el-form-item label="支付方式" prop="style" class="zdybkys">
          <el-checkbox v-model="formdata.wechat">微信</el-checkbox>
          <el-checkbox v-model="formdata.alipay">支付宝</el-checkbox>
        </el-form-item>
        <el-form-item label="描述" prop="describe">
          <el-input type="textarea" :rows="2" placeholder="请输入描述" v-model="formdata.describe">
          </el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="handleClose" style="padding:8px 35px;">取 消</el-button>
        <el-button type="primary" style="padding:8px 35px;background:#1677ff" @click="submitData('新增')">确认</el-button>
      </div>
    </el-dialog>
    <!-- 编辑 -->
    <el-dialog title="编辑" :visible.sync="dialogFormVisiblr" :close-on-click-modal="false" class="zdyxzcpzk"
      width="692px" :before-close="handleClose">
      <el-form :rules="rules" ref="dialogformdata1" :model="formdata" :inline="false">
        <el-form-item label="增值服务名称" prop="name">
          <el-input clearable v-model="formdata.name" size="small" autocomplete="off"
            placeholder="请输入增值服务名称"></el-input>
        </el-form-item>
        <el-form-item label="单价" prop="price">
          <el-input clearable v-model="formdata.price" size="small" autocomplete="off" placeholder="请输入单价"></el-input>
        </el-form-item>
        <el-form-item label="支付方式" prop="style" class="zdybkys">
          <el-checkbox v-model="formdata.wechat">微信</el-checkbox>
          <el-checkbox v-model="formdata.alipay">支付宝</el-checkbox>
        </el-form-item>
        <el-form-item label="描述" prop="describe">
          <el-input type="textarea" :rows="2" placeholder="请输入描述" v-model="formdata.describe">
          </el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="handleClose" style="padding:8px 35px;">取 消</el-button>
        <el-button type="primary" style="padding:8px 35px;background:#1677ff" @click="submitData('编辑')">确认</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import excel from '@/libs/excel'
import bcrypt from 'bcryptjs';
export default {
  data() {
    return {
      picUrl: process.env.VUE_APP_PIc_URL,
      selectedUser: null,
      alldelete: false,
      shownumber: false,
      dialogFormVisible: false,
      dialogFormVisiblr: false,
      formLabelWidth: '70px',
      startdate: '',
      enddate: '',
      fuserList: null,
      userList: [],
      // dataList: [],
      search: '',
      searchphone: '',
      checkAll: '',
      currentPage: 1,
      itemsPerPage: 16,
      dialogImageUrl: '',
      dialogVisible: false,
      disabled: false,
      flag: '',
      form: {
        networknum: '',
        equipmentnum: ''
      },
      rules: {
        name: [
          { required: true, message: '请输入增值服务名称', trigger: ['change', 'blur'] },
        ],
        price: [
          { required: true, message: '请输入单价', trigger: ['change', 'blur'] },
          {
            pattern: /^-?\d+(\.\d*)?$/,
            message: '必须为有效数字',
            trigger: ['change', 'blur']
          }
        ],
        style: [
          {
            validator: (rule, value, callback) => {
              if (this.formdata.alipay == false && this.formdata.wechat == false) {
                callback(new Error('请至少选择一种支付方式'))
              } else {
                callback()
              }
            },
            trigger: ['change', 'blur']
          }
        ],
        describe: [
          { required: true, message: '请输入描述', trigger: ['change', 'blur'] },
        ]
      },
      token: localStorage.getItem('token'),
      uploadUrl: process.env.VUE_APP_BASE_URL + '/upload/image',
      formdata: {
        id: '',
        name: '',
        price: '',
        style: '',
        alipay: false,
        wechat: false,
        describe: '',
      },
      guja: {
        version: '',
        date: '',
        url: '',
        name: ''
      },
      gujb: {
        version: '',
        date: '',
        url: '',
        name: ''
      },
      gujc: {
        version: '',
        date: '',
        url: '',
        name: ''
      },
      delid: '',//删除时的临时id
      rolelist: [],
      srcList: ['http://test.hi-wooya.com/headimg/upload_7802168047da2bcd564b947c76a525e9.png'],
      gujy: '',
      guje: '2',
      gujs: '3',
      current: 1,
      size: 10,
    }
  },
  created() {
    this.$js.token();
    //sessionStorage.setItem('tabid', '8');
    sessionStorage.setItem('path', '/Admindata');
    sessionStorage.setItem('netpage', '1');
    this.selectuser()
    this.changeheight()
  },
  computed: {
  },
  methods: {
    // 获取页面大小
    changeheight() {
      if (document.documentElement.clientHeight <= 800 && document.documentElement.clientHeight > 750) {
        this.itemsPerPage = 12
      } else if (document.documentElement.clientHeight <= 750 && document.documentElement.clientHeight > 720) {
        this.itemsPerPage = 11
      } else if (document.documentElement.clientHeight < 720) {
        this.itemsPerPage = 7
      }
    },
    // 删除成员
    async userDelete(id) {
      // console.log(id);
      let res = await this.$apiFun.valueaddeddelete(id)
      //alert(res)
      if (res.code == 200) {
        this.$message({
          message: res.msg,
          type: 'success'
        });
        this.delid = '';
        this.selectuser();
      }
    },
    // 展示删除框
    shownotice(item) {
      //   if (item.notice) {
      //     item.notice = !item.notice
      //   } else {
      //     this.fuserList.forEach(item => {
      //       item.notice = false
      //     })
      //     item.notice = !item.notice
      //   }
      this.delid = item;
    },
    handleSizeChange(val) {
      //console.log(`每页 ${val} 条`);
      this.size = val;
      this.selectuser();
    },
    handleCurrentChange(val) {
      //console.log(`当前页: ${val}`);
      this.current = val;
      this.selectuser();
    },
    // 搜索功能
    async handleSearch() {
      let res = await this.$apiFun.valueaddedlist({ flag: this.flag, current: this.current, size: this.size });
      if (res.code == 200) {
        this.userList = res.data.records
        this.fuserList = res.data.total
      } 
    },
    //验证方法
    verificationbd(type) {
      if (type == "新增") {
        // 新增
        this.$refs.dialogformdata.validate(async (valid) => {
          if (valid) {
            const res = await this.$apiFun.valueaddedadd({ name: this.formdata.name, price: this.formdata.price, wechat: this.formdata.wechat == false ? 0 : 1, alipay: this.formdata.alipay == false ? 0 : 1, describe: this.formdata.describe })
            console.log(res, 'dddd');
            if (res.code == 200) {
              this.$message({
                message: res.msg,
                type: 'success'
              });
              this.handleClose()
              this.selectuser();
            } else {
              this.$message({
                message: res.msg,
                type: 'error'
              });
            }
          } else {
            // console.log('error submit!!');
            return false;
          }
        });
      } else {
        // 编辑
        this.$refs.dialogformdata1.validate(async (valid) => {
          if (valid) {
            const res = await this.$apiFun.valueaddedupdate({ id: this.formdata.id, name: this.formdata.name, price: this.formdata.price.toString(), wechat: this.formdata.wechat == false ? 0 : 1, alipay: this.formdata.alipay == false ? 0 : 1, describe: this.formdata.describe })
            console.log(res, 'dddd');
            if (res.code == 200) {
              this.$message({
                message: res.msg,
                type: 'success'
              });
              this.handleClose()
              this.selectuser();
            } else {
              this.$message({
                message: res.msg,
                type: 'error'
              });
            }
          } else {
            // console.log('error submit!!');
            return false;
          }
        });
      }
    },
    //提交数据
    async submitData(type) {
      //this.formdata.id = data.id
      this.verificationbd(type);
      //let res = await this.$apiFun.addnet({ netname, userid, username, parentid,label,project });
    },
    handleClose() {
      this.dialogFormVisible = false
      this.dialogFormVisiblr = false
      this.$refs.dialogformdata?.resetFields();
      this.$refs.dialogformdata1?.resetFields();
      this.formdata.name = '';
      this.formdata.price = '';
      this.formdata.style = '';
      setTimeout(() => {
        this.formdata.alipay = '';
        this.formdata.wechat = '';
      }, 100);
      this.formdata.describe = '';
    },
    //查询增值服务列表
    async selectuser() {
      // let id = JSON.parse(sessionStorage.getItem('user')).id
      let res = await this.$apiFun.valueaddedlist({ current: this.current, size: this.size });
      if (res == false) {
        console.log(res);
      } else {
        this.userList = res.data.records
        this.fuserList = res.data.total
      }
    },
    addValueAdd() {
      this.dialogFormVisible = true
      this.$refs.dialogformdata?.resetFields();
    },
    changeValueAdd(item) {
      this.dialogFormVisiblr = true
      this.formdata.id = item.id
      this.formdata.name = item.name
      this.formdata.price = Number(item.price)
      this.formdata.alipay = item.alipay == 1 ? true : false
      this.formdata.wechat = item.wechat == 1 ? true : false
      this.formdata.describe = item.describe
    },
  }
}
</script>

<style scoped lang="less">
.content-box {
  display: flex;
  flex: 1;
  flex-direction: column;
  justify-content: space-between;
  position: relative;
  padding: 0 1.1%;
  background-color: white;
  overflow-y: hidden;
  overflow-x: auto;
  white-space: nowrap;
}

.tab {
  font-size: 12px;
  padding-top: 10px;
  height: 38.8px;
  line-height: 38.8px;
}

.title-box {
  margin: 20px 0px 10px;
  height: 30px;
  display: flex;
  justify-content: space-between;
  border-bottom: 1px solid #ebeef5;
}

.title {
  font-size: 14px;
  font-weight: 700;
}

.btn-box {
  margin: -15px 0px 0px 0px;
  display: flex;
}

.addbox {
  position: fixed;
  top: 40%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 600px;
  height: 300px;
  z-index: 999;
  background-color: white;
}

.addtitle {
  padding: 25px 0px 0px 15px;
  font-size: 14px;
  font-weight: bold;
}

.addtable {
  margin-top: 40px;
  padding: 0px 80px;
}

.addbtn {
  height: 30px;
  line-height: 30px;
  background: #fafafa;
  padding: 0px 25px;
  font-size: 14px;
  border: 1px solid #dcdcdc;
  margin-left: 10px;
  cursor: pointer;
}

.notice {
  color: #333333;
  z-index: 999;
}

.overlay {
  position: fixed;
  top: 0px;
  left: 0px;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.5);
  /* 半透明黑色背景 */
  z-index: 999;
  /* 确保在上层 */
}

.deleteallbox {
  position: fixed;
  top: 40%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 999;
  background-color: white !important;
}

/* .userkbtn:hover {
  color: #70c31d;
  cursor: pointer;
} */

.exportimg {
  width: 14px;
  height: 14px;
  margin-right: 10px;
}

.select-box {
  display: flex;
}

.select {
  margin: 0px 10px 20px 0px;
}

.search {
  margin: 0px 10px 20px 0px;
  line-height: 32px;
  padding: 0 16px;
  background-color: #1677ff;
  color: white;
  cursor: pointer;
  font-size: 12px;
}

.networkListtitle {
  min-width: 1610px;
  font-size: 12px;
  box-sizing: border-box;
  position: relative;
  display: flex;
  padding: 0 8px;
  font-weight: bold;
  background-color: #fafafb;
  display: flex;
  border-top: 1px solid #ebeef5;
  border-bottom: 1px solid #ebeef5;
}

.inputcheck {
  display: flex;
}

.username {
  width: 300px;
}

.select-box:deep(.el-input__inner) {
  width: 151px;
  height: 32px;
}

.select-box:deep(.el-date-editor.el-input, .el-date-editor.el-input__inner) {
  width: 150px;
}

.select-box:deep(.el-input__icon) {
  line-height: 32px;
}

.select:deep(.el-input__inner:focus) {
  border-color: #012f55;
}

.select:deep(.el-input.is-focus .el-input__inner) {
  border-color: #012f55;
}

.zdyxzcpzk:deep(.el-dialog__header) {
  padding: 20px 20px 0px;
}

.zdyxzcpzk:deep(.el-dialog__body) {
  padding: 5px 20px;
}

.zdyxzcpzk:deep(.el-dialog) {
  margin-top: 5vh !important;
}

.zdyxzcpzk:deep(.el-form-item) {
  margin-bottom: 10px;
}

.zdyxzcpzk:deep(.el-upload-list) {
  display: none;
}

.zdycpt:deep(.el-form-item__label) {
  float: unset !important;
}

.zdycpt:deep(.el-form-item__content) {
  border: 1px solid #ddd;
  background: #fbfbfb;
  padding: 20px;
  font-size: 35px;
  color: #1677ff;
}

.avatar-uploader {
  width: 100px;
  height: 100px;
  border: 1px dotted #cfcccc;
  text-align: center;
}

.zdybkys:deep(.el-form-item__label) {
  float: unset !important;
}

.zdybkys:deep(.el-form-item__content) {
  border: 1px solid #ddd;
  background: #fbfbfb;
  padding: 10px 30px;
}

.btn {
  display: flex;
  align-items: center;
  padding: 0px 16px;
  height: 32px;
  line-height: 32px;
  margin: 0px 10px 0px 0px;
  border: 1px solid #e7e9f1;
  cursor: pointer;
  font-size: 12px;
  color: #fff;
}

.addbtn {
  height: 30px;
  line-height: 30px;
  background: #fafafa;
  padding: 0px 25px;
  font-size: 14px;
  border: 1px solid #dcdcdc;
  margin-left: 10px;
  cursor: pointer;
}

.deleteallbox {
  position: fixed;
  top: 40%;
  left: 50%;
  transform: translate(-50%, -50%);
  /* width: 210px; */
  /* height: 100px; */
  z-index: 999;
  background-color: white !important;
}

.userList {
  min-width: 1610px;
  display: flex;
  border-bottom: 1px solid #ebeef5;
  padding: 8px;
  font-size: 12px;
}

.userList:hover {
  background: #fafafb;
}

.usermobile {
  width: 300px;
  flex-shrink: 0;
  display: flex;

  p {
    &:nth-child(1) {
      margin-right: 15px;
    }
  }
}

.userfirm {
  width: 600px;
  text-overflow: ellipsis;
  overflow: hidden;
  flex-shrink: 0;
}

.useremail {
  width: 300px;
  flex-shrink: 0;
}

.userdate {
  width: 580px;
  flex-shrink: 0;
}

.networknum {
  width: 19.22%;
  flex-shrink: 0;
}

.equipmentnum {
  width: 9.22%;
  flex-shrink: 0;
}

.networkoperate {
  position: relative;
  width: 100px;
  display: flex;
}

.userkbtn {
  color: #1677ff;
  border: none;
  cursor: pointer;
  height: 100%;
  margin-right: 6px;

  &:last-child {
    margin-right: 0;
  }
}

.inputcheck:deep(.el-checkbox__inner) {
  background: #edf2fc;
  border-color: #dcdfe6;
}

.inputcheck:deep(.el-checkbox__inner) {
  background: #edf2fc;
  border-color: #dcdfe6;
}

.inputcheck:deep(.el-checkbox__input.is-focus .el-checkbox__inner) {
  border-color: #012f55;
}

.inputcheck:deep(.el-checkbox__input.is-checked .el-checkbox__inner,
  .el-checkbox__input.is-indeterminate .el-checkbox__inner) {
  background: #012f55;
  border-color: #012f55;
}

.select:deep(.el-input__inner) {
  line-height: 32px;
}

.select:deep(.el-input__inner:hover) {
  border-color: #012f55;
}

.notice:deep(.el-input__inner:focus) {
  border-color: #012f55;
}

.notice:deep(.el-input.is-focus .el-input__inner) {
  border-color: #012f55;
}

.titlebox {
  padding: 8px 0px;
  background-color: #fafafb;
}

:deep(.el-form) {
  .zdybkys {
    .el-form-item__label {
      position: relative;

      &:after {
        content: "*";
        display: block;
        position: absolute;
        top: -10px;
        right: 0;
        color: rgb(255, 80, 80);
      }
    }
  }
}

@media screen and (min-width: 1680px) {
  .titlebox {
    padding: 8px 0px;
    border: none;
  }

  .networkListtitle {
    background-color: #fafafb;
    border-top: 1px solid #e7e9f1;
    border-bottom: 1px solid #e7e9f1;
  }
}
</style>